<template>
    <div class="shareUrlBox">
        <tabs>
            <tab title="URL" :is-active="true">
                <form class="form-inline">
                    <div class="form-group mx-sm-3">
                        <label for="url" class="sr-only">URL</label>
                        <input type="url" class="form-control" id="url" v-model="url" placeholder="URL">
                    </div>
                    <button type="submit" class="btn btn-primary" @click.prevent="trigger">Copy</button>
                    <p class="shareUrlBox__text"><a v-if="url" :href="url" target="_blank">Open in a new window</a></p>
                </form>
            </tab>
            <tab title="Email" ref="emailTab">
                <form class="form-inline">
                    <p>Email <strong>{{ url }}</strong> to:</p>
                    <div class="form-group mx-sm-3">
                        <label for="email" class="sr-only">Email</label>
                        <input type="email" class="form-control" id="email" placeholder="hello@youremail.com">
                    </div>
                    <p class="shareUrlBox__text"><a @click.prevent="toggleMessage" class="shareUrlBox__link" href><i :class="messageIcon"></i> {{ message }}</a></p>
                    <textarea :class="`form-control${showMessage ? '' : ' hidden'}`" rows="5" id="comment"></textarea>
                </form>
            </tab>
        </tabs>
    </div>
</template>

<script>
import Tabs from '@/components/Tabs/tabs'
import Tab from '@/components/Tabs/tab'

export default {
  name: 'ShareUrlBox',
  components: {
    Tabs,
    Tab
  },
  props: {},
  mounted () {
  },
  data: () => ({
    url: null,
    showMessage: false
  }),
  computed: {
    message () {
      return `${this.showMessage ? 'Hide' : 'Show'} personalised message`
    },
    messageIcon () {
      return `${this.showMessage ? 'fa fa-minus' : 'fa fa-plus'}`
    }
  },
  methods: {
    toggleMessage () {
      this.showMessage = !this.showMessage
    },
    trigger () {
      this.$refs.emailTab.$el.click()
    }
  }
}
</script>

<style lang="scss">
    @import "./share-url-box";
</style>



// WEBPACK FOOTER //
// src/components/ShareUrlBox/share-url-box.vue